/**
 * Created by Jession on 2018/04/03
 * function 财务管理
 */
import {config, request} from 'Utils';

/**
 * 财务管理
 * @param param
 * @returns {*}
 */
/*export function getShoppingCarList() {
  return request(`${config.server}/api/v1/dms/salesQuery/list`, {
    method: 'get'
  });
}*/
/* 销售查询（收款类型）
 * @param param
 */
export function getSalesQueryList(param) {
  return request(`${config.server}/api/v1/dms/trans/order/salesQueryList`, {
    method: 'post',
    body: param
  });
}

/* 回款列表（客户回款核销）
 * @param param
 */
export function recoverListByPage(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/listByPage`, {
    method: 'post',
    body: param
  });
}

/* 回款列表导出（客户回款核销）
 * @param param
 */
export function recoverListExportExcel(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/exportRecover`, {
    method: 'get',
    body: param
  });
}

/* 回款详情（客户回款核销）
 * @param param
 */
export function receivedPaymentDetail(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/detail`, {
    method: 'post',
    body: param
  });
}

/* 新增回款（客户回款核销）
 * @param param
   * {
    "cusId": 8009,  // 客户名称Id
    "recoverCount": 8000,  // 收款金额
    "recoverDate": "2018-03-30 06:58:33",  // 收款日期
    "recoverType": "对公转账",  // 收款方式
    "remark": "sssssssssss",  // 备注
    "attachmentDto": [  // 附件数组
      attachId  // 附件id
    ]
  }
 */
export function recoverCreate(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/create`, {
    method: 'post',
    body: param
  });
}

/* 回款核销选择列表（客户回款核销）
 * @param param
    {
      orderDateStart  // 订单日期（起）
      orderDateEnd  // ("订单日期（止）")
    }
 */
export function orderWritenoffList(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/orderWritenoffList`, {
    method: 'post',
    body: param
  });
}

/* 回款核销提交（客户回款核销）
 * @param param
 * {  
    id: id,   // 回款id
    writenoffCountCur: // 本次核销金额汇总
    writenoffDetailVos: [
      {
        orderId //订单id
        writenoffCountCur //本次核销金额
      }
    ]
  }
 */
export function recoverWritenoff(param) {
  return request(`${config.server}/api/v1/dms/trans/recover/recoverWritenoff`, {
    method: 'post',
    body: param
  });
}

/*二级客户列表*/
export function secondClientList(param) {
  return request(`${config.server}/api/v1/dms/employee/secondList`, {
  method: 'post',
  body: {...param},
  });
}

/* 应付记录列表
 * @param param
 */
export function getPaymentList(param) {
  return request(`${config.server}/api/v1/dms/trans/risk/listByPage`, {
    method: 'post',
    body: param
  });
}

/* 应付记录详情
 * @param param
 */
export function getPaymentDetail(param) {
  return request(`${config.server}/api/v1/dms/trans/risk/detail`, {
    method: 'post',
    body: param
  });
}

/* 应付记录详情中已付记录列表
 * @param param
    {
      "riskId": 1
      "p":
      "s"
    }
 */
export function payListByriskId(param) {
  return request(`${config.server}/api/v1/dms/trans/riskPay/listByriskId`, {
    method: 'post',
    body: param
  });
}

/* 新增应付记录
 * @param param
  {
    riskDate // 应付日期
    cusname // 客户名称
    riskType // 费用类型
    orderCount // 应付金额
    remark // 备注
  }
 */
export function addPaymentList(param) {
  return request(`${config.server}/api/v1/dms/trans/risk/create`, {
    method: 'post',
    body: param
  });
}

/* 付款（应付记录）
 * @param param
  {
    riskId // 应付id
    riskDate // 付款日期
    riskCount // 付款金额
  }
 */
export function addRiskPay(param) {
  return request(`${config.server}/api/v1/dms/trans/riskPay/create`, {
    method: 'post',
    body: param
  });
}

/* 应付核销提交（应付记录）
 * @param param
 * {  
    id: id,   // 回款id
    writenoffCountCur: // 本次核销金额汇总
    tgTransWritenoffs: [
      {
        orderId //订单id
        writenoffCountCur //本次核销金额
      }
    ]
  }
 */
export function riskWritenoff(param) {
  return request(`${config.server}/api/v1/dms/trans/risk/riskWritenoff`, {
    method: 'post',
    body: param
  });
}

/* 已付记录（应付记录）
 * @param param
 */
/*export function riskWritenoff(param) {
  return request(`${config.server}/api/v1/dms/trans/riskPay/create`, {
    method: 'post',
    body: param
  });
}*/

/* 财务对账
 * @param param
 */
export function getVerifyingList(param) {
  return request(`${config.server}/api/v1/dms/trans/check/listByPage`, {
    method: 'post',
    body: param
  });
}

/* 财务账期
 * @param param
 */
export function getCheckMonth(param) {
  return request(`${config.server}/api/v1/dms/trans/check/getCheckMonth`, {
    method: 'post',
    body: param
  });
}

/* 财务确认
 * @param param
    {
      checkDate // 账期（yyyyMM
      cusId // 客户id
      startAmount // 期初金额
      endAmount // 期末金额
      receiveShould // 应收
      riskCountShould // 应付总额
      riskCountReal // 已付总额
      recoverAmount // 回款总额
    }
 */
export function confirmFinanceCheck(param) {
  return request(`${config.server}/api/v1/dms/trans/check/create`, {
    method: 'post',
    body: param
  });
}

/* 其他信息录入（新增）
 * @param param
    {
      otherDate // 日期
      otherCount  // 金额
      otherType // 费用类型
      remark  // 备注
    }
 */
export function addOtherInfor(param) {
  return request(`${config.server}/api/v1/dms/trans/othermsg/create`, {
    method: 'post',
    body: param
  });
}

/* 其他信息录入（列表）
 * @param param
 */
export function getOtherInforList(param) {
  return request(`${config.server}/api/v1/dms/trans/othermsg/listByPage`, {
    method: 'post',
    body: param
  });
}

/* 核销明细报表
 * @param param
  {
    startDate   // 开始日期 yyyy-MM-dd HH:mm:ss
    endDate // 结束日期
    orderType // 订单类型
    cusName // 客户名称
  }
 */
export function writenoffDetailList(param) {
  return request(`${config.server}/api/v1/dms/trans/check/writenoffwDetailPo`, {
    method: 'post',
    body: param
  });
}



// WEBPACK FOOTER //
// ./src/service/financialMgm/index.js